import type {
  GltfLoadingOptionsInput,
  GltfTextureMaxSize,
} from '@sharefe/share3d-engine'

export const MESH_TEXTURE_MAX_SIZE_OPTIONS = [
  { value: 'auto', label: '自动' },
  { value: 256, label: '256 px' },
  { value: 512, label: '512 px' },
  { value: 1024, label: '1024 px' },
  { value: 'original', label: '原始尺寸' },
] as const

export const MESH_GLTF_LOAD_MODE_OPTIONS = [
  { value: 'auto', label: '自动' },
  { value: 'low-memory', label: '低内存（Range）' },
  { value: 'standard', label: '标准（完整文件）' },
] as const

export const MESH_TEXTURE_CONCURRENCY_OPTIONS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
] as const

export const MESH_CHILD_CONCURRENCY_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8] as const

export type MeshTextureConcurrencyOption = (typeof MESH_TEXTURE_CONCURRENCY_OPTIONS)[number]

export type MeshChildConcurrencyOption = (typeof MESH_CHILD_CONCURRENCY_OPTIONS)[number]

export type MeshGltfLoadModeOption = (typeof MESH_GLTF_LOAD_MODE_OPTIONS)[number]['value']

export type MeshTextureMaxSizeOption =
  (typeof MESH_TEXTURE_MAX_SIZE_OPTIONS)[number]['value']

export interface MeshExampleGltfLoaderConfig {
  readonly loading: GltfLoadingOptionsInput
  setTextureMaxSize(value: MeshTextureMaxSizeOption): void
}

export function resolveMeshTextureMaxSize(value: MeshTextureMaxSizeOption): GltfTextureMaxSize {
  return value === 'original' ? Number.POSITIVE_INFINITY : value
}

/** 创建 Mesh example 单次加载使用的 glTF 模式与纹理并发配置。 */
export function createMeshExampleGltfRequestOptions(
  mode: MeshGltfLoadModeOption,
  textureConcurrency: MeshTextureConcurrencyOption
): GltfLoadingOptionsInput {
  return {
    mode,
    texture: { maxConcurrentDecodes: textureConcurrency },
  }
}

/** 创建可在后续加载前更新纹理档位的 example GLTF Loader 配置。 */
export function createMeshExampleGltfLoaderConfig(
  initialMaxSize: MeshTextureMaxSizeOption = 'auto'
): MeshExampleGltfLoaderConfig {
  const loading: GltfLoadingOptionsInput = {
    mode: 'auto',
    unsupportedMode: 'fallback',
    texture: { maxSize: resolveMeshTextureMaxSize(initialMaxSize) },
  }

  return {
    loading,
    setTextureMaxSize(value) {
      loading.texture = { maxSize: resolveMeshTextureMaxSize(value) }
    },
  }
}
